import { render, staticRenderFns } from "./SafraManage.vue?vue&type=template&id=16cbb9c2&scoped=true"
import script from "./SafraManage.vue?vue&type=script&lang=js"
export * from "./SafraManage.vue?vue&type=script&lang=js"
import style0 from "./SafraManage.vue?vue&type=style&index=0&id=16cbb9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbb9c2",
  null
  
)

export default component.exports